<template>
  <section class="container center">
    <vs-row align="center" justify="center" v-if="error">
      <vs-col :lg="5" :sm="8" :xs="11">
        <vs-alert color="danger">
          <template #icon>
            <i class="bx bxs-error"></i>
          </template>
          <div>
            <span v-if="errorMessage" v-html="errorMessage"></span><span v-else>Oops! Something went wrong</span> <br>Please click <a id="link-views-home-here" @click="popupActivo=true" >here</a> if you need to know more details about that.
          </div>
        </vs-alert>
        <vs-dialog v-model="popupActivo" @close="handleClose" class="modal-contact-us">

          <div v-if="messageSent" >
            <vs-row vs-type="flex" align="center" justify="center" class="modal-message">
              <vs-col
                :xs="12"
                :sm="12"
                :lg="12"
                vs-type="flex"
                align="center"
                justify="center"
                class="first-name"
              >
                <h2> Thanks. Your message has been sent!</h2>
              </vs-col>
            </vs-row>
          </div>
          <form @submit.prevent="contactUsForm" v-if="!messageSent">
            <vs-row vs-type="flex" align="center" justify="center">

              <vs-col
                  :xs="12"
                  :sm="12"
                  :lg="6"
                  vs-type="flex"
                  align="center"
                  justify="center"
                  class="first-name"
                >
                <vs-input
                  id="input-views-home-firstname"
                  label="FIRST NAME*"
                  v-model="modal.firstName"
                  color="#83bc00"
                  required
                />
              </vs-col>
              <vs-col
                  :xs="12"
                  :sm="12"
                  :lg="6"
                  vs-type="flex"
                  align="center"
                  justify="center"
                >

                <vs-input
                  id="input-views-home-lastname"
                  label="LAST NAME*"
                  v-model="modal.lastName"
                  color="#83bc00"
                  required
                />
              </vs-col>

            </vs-row>

            <vs-row vs-type="flex" align="center" justify="center">

              <vs-col
                  :xs="12"
                  :sm="12"
                  :lg="12"
                  vs-type="flex"
                  align="center"
                  justify="center"
                >
                <vs-input
                  id="input-views-home-email"
                  label="EMAIL*"
                  type="email"
                  v-model="modal.email"
                  color="#83bc00"
                  required
                />
              </vs-col>

            </vs-row>

            <vs-row vs-type="flex" align="center" justify="center">

              <vs-col
                  :xs="12"
                  :sm="12"
                  :lg="12"
                  vs-type="flex"
                  align="center"
                  justify="center"
                >
                <vs-input
                  id="input-views-home-message"
                  label="MESSAGE*"
                  v-model="modal.message"
                  color="#83bc00"
                  required
                />
              </vs-col>

            </vs-row>

            <vs-row vs-type="flex" align="center" justify="center">

              <vs-col
                  :xs="12"
                  :sm="12"
                  :lg="12"
                  vs-type="flex"
                  align="center"
                  justify="center"
                >
                <vs-input
                  id="input-views-home-description"
                  label="ADDITIONAL DETAILS"
                  v-model="modal.description"
                  placeholder=""
                  color="#83bc00"
                />

              </vs-col>

            </vs-row>
            <div class="footer-dialog">
              <vs-button id="btn-views-home-sendmessage" block color="#83bc00" :loading="loadingModal">
                Send Message
              </vs-button>
            </div>
          </form>
        </vs-dialog>
      </vs-col>
    </vs-row>
    <vs-row  vs-type="flex" :w="12" align="center" justify="center">
      <landing
        :promoName="promoName"
        :logo="logo"
        :logo_url="logoUrl"
        :code="code"
        :contentCopies="contentCopies"
        :allowGiftSite="allowGiftSite"
        @error="handleError"
        @success="landingSuccess"
        v-if="step === 'LANDING'"
      ></landing>
      <checkout
        :promoName="promoName"
        :logo="logo"
        :logo_url="logoUrl"
        :code="code"
        :addressValidation="allowOneAddress"
        :validation="validationFields"
        :allowPhone="allowPhone"
        :contentCopies="contentCopies"
        :allowGiftSite="allowGiftSite"
        @success="checkoutSuccess"
        @error="handleError"
        v-if="step === 'CHECKOUT'"
      ></checkout>
      <prizes
        :token="code"
        :logo="logo"
        :logo_url="logoUrl"
        :promoName="promoName"
        :contentCopies="contentCopies"
        :allowSize="allowSize"
        :allowGiftSite="allowGiftSite"
        @success="prizeSuccess"
        @goCheckout= "goCheckout"
        v-if="step === 'PRIZE'"
      ></prizes>
      <confirmation
        :logo="logo"
        :logo_url="logoUrl"
        :promoName="promoName"
        :prize="prize"
        :token="code"
        :checkout="checkout"
        :contentCopies="contentCopies"
        :allowGiftSite="allowGiftSite"
        @success="confirmationSuccess"
        @error="handleError"
        @pickPrize="goPrize"
        v-if="step === 'CONFIRMATION'"
      ></confirmation>
      <thank-you :email="email" :logo="logo" :logo_url="logoUrl" v-if="step === 'THANKYOU'"></thank-you>
    </vs-row>
  </section>
</template>

<script>
import Landing from '@/components/Landing';
import Prizes from '@/components/Prizes';
import Checkout from '@/components/Checkout';
import Confirmation from '@/components/Confirmation';
import ThankYou from '@/components/ThankYou';

export default {
  name: 'Home',
  components: {
    Landing,
    Prizes,
    Checkout,
    Confirmation,
    ThankYou,
  },
  methods: {
    adjustAlertSize() {
    const alertBox = document.querySelector(".vs-alert__content");
    if (alertBox) {
      alertBox.style.minHeight = "auto";
      alertBox.style.height = "auto";
    }
  },
    handleClose (){
      if(this.messageSent){

        var parameter =  'code';
        var url=document.location.href;
        var urlparts= url.split('?');

        if (urlparts.length>=2)
        {
          var urlBase=urlparts.shift(); 
          var queryString=urlparts.join("?"); 

          var prefix = encodeURIComponent(parameter)+'=';
          var pars = queryString.split(/[&;]/g);
          for (var i= pars.length; i-->0;)               
              if (pars[i].lastIndexOf(prefix, 0)!==-1)   
                  pars.splice(i, 1);
          url = urlBase+'?'+pars.join('&');
          window.history.pushState('',document.title,url);

        }
        location.reload();
      }
    },
    contactUsForm() {
      this.loadingModal = true;
      this.modal.description = this.modal.description ? this.modal.description : "-";
      // send the code.
      const reqParams = { 
        ...this.modal,
        description: this.modal.description + ' (code: ' + this.code +')',
        code: this.code,
      };
      if(this.code) {
        reqParams.code = this.code;
      }
      this.$http
        .post(`redeem/notification/contactus`, reqParams)
        .then(result => {

          if(result.data.status === 'success'){
            this.loadingModal = false;
            this.messageSent = true;
            this.modal = {};
          }
        })
        .catch(() => {
          this.loadingModal = false;
        });
    },
    handleError(message, fatal = false, code = '') {
      this.error = true
      this.errorMessage = message ? message : '';
      this.modal.description = this.errorMessage;
      this.code = code ? code : this.code;
      if (fatal) {
        this.prize = null;
        this.code = code ? code : '';
        this.checkout = null;
        this.step = 'LANDING';
      }
    },
    landingSuccess(promoName, code, validationAddress, allowGiftSite = false, rewardSiteData = null, activeSizeField = false) {
      this.error = null;
      this.step = 'CHECKOUT';
      this.promoName = promoName;
      this.code = code;
      
      this.allowOneAddress = !!parseInt(validationAddress);
      this.allowSize = activeSizeField;
      this.allowGiftSite = allowGiftSite;
      if(allowGiftSite && rewardSiteData) {
        this.contentCopies = {
          ...this.contentCopies,
          ...rewardSiteData,
        };
      }
    },
    checkoutSuccess(checkout) {
      this.error = null;
      this.step = 'PRIZE';
      this.checkout = checkout;
    },
    prizeSuccess(selectedPrize, priceSize) {
      this.error = null;
      this.step = 'CONFIRMATION';
      this.prize = selectedPrize;
      if(this.checkout)
        this.checkout.size = priceSize;
    },
    confirmationSuccess() {
      this.email = this.checkout.email;
      this.prize = null;
      this.code = '';
      this.checkout = null;
      this.step = 'THANKYOU';
    },
    goPrize() {
      this.step = 'PRIZE';
    },
    goCheckout(){
      this.step = 'CHECKOUT';
    },
    validateToken() {
      this.code = this.$route.query.code;
      const loading = this.$vs.loading({color:'#83bc00'});
      
      if (!this.code) {
        setTimeout(() => loading.close(), 1000);
        return;
      }
      
      
      this.$http
      .get(`redeem/winners/token/load?redeemToken=${this.code}`)
        .then(result => {
          if (result.data.valid) {
            this.promoName = result.data.promo_name;
            this.validationFields = result.data.validation;
            this.allowSize = result.data.active_size_field;
            this.allowPhone = result.data.active_phone_field;
            this.allowGiftSite = result.data.allow_gift_site;
            if(result.data.allow_gift_site) {
              this.contentCopies = {
                ...this.contentCopies,
                ...result.data.reward_site_data,
              };
            }
            this.logo = result.data.logo;
            this.logoUrl = result.data.logo_url ? result.data.logo_url : result.data.logo;
            this.error = false;
          } else {
            this.error = true;
          }
          setTimeout(() => loading.close(), 1000);
        }).catch((error) => {
          loading.close();
          this.handleError(this.getErrorMessage(error))
        });  
    },
  },
  data() {
    return {
      code: '',
      promoName: null,
      allowSize: false,
      allowPhone: false,
      error: false,
      step: 'LANDING',
      prize: {},
      checkout: {},
      email: '',
      validationFields: '',
      logo:null,
      logoUrl: null,
      popupActivo:false,
      modal:{},
      loadingModal:false,
      messageSent:false,
      errorMessage:"",
      allowOneAddress: false,
      allowGiftSite: false,
      contentCopies: {
        confirm_body: "We don’t Want It Sent To The Wrong Person!",
        confirm_btn_text: "CONFIRM MY PRIZE",
        confirm_header: "PLEASE CONFIRM YOUR PRIZE",
        claim_text: "CLAIM MY PRIZE",
        form_label_terms: "Yes, the information provided above is correct and matches my official entry and if not, I will forfeit the right to redeem my prize per the official rules.",
        prize_body: "Here is what you won! <br/>Please select your prize",
        prize_header: "CONGRATS!",
        prize_label_size: "If a size is needed, please provide it below",
        welcome_body: "Please confirm your’re not a robot and hit enter to claim your prize!",
        welcome_header: "CONGRATULATIONS!",
      },
    };
  },
  created() {
    this.validateToken();
  },
  mounted() {
  window.addEventListener("resize", this.adjustAlertSize);
},

beforeDestroy() {
  window.removeEventListener("resize", this.adjustAlertSize);
},

};
</script>

<style lang="scss" scoped>
section {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 150px);
  padding: 75px 0 150px 0;
  @media (max-width: 900px) {
    padding-bottom:265px;
  }
}
::v-deep form {
  input{
    width: 100%;
  }
  .vs-input-parent{
    margin-top: 2rem;
  }
  .first-name{
    padding-right:5px;
  }
  .footer-dialog{
    margin-top:2rem;
  }
}

::v-deep .modal-message{
  padding-top:25px;
}

.vs-alert {
  min-height: auto !important;
  height: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;
  word-wrap: break-word;
  white-space: normal;
}

.vs-alert__content {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
